// Base URL of the Sendola app this landing points to. Configured per
// environment via VITE_APP_BASE_URL. Trailing slash is stripped so paths
// can be appended safely.
const appBaseUrl = (import.meta.env.VITE_APP_BASE_URL ?? "").replace(/\/+$/, "");

export const appUrls = {
  signUp: `${appBaseUrl}/signup`,
  login: `${appBaseUrl}/login`,
};
